import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { PROJECT_API } from "./apiRoutes";

interface mutateProps {
  projectId: string;
  data: any
}

const mutateAddPlan = async ({projectId, data}: mutateProps) => {
  return await axiosAuth.post(`${PROJECT_API}/${projectId}/plans`, data);
};

const useAddPlanMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateAddPlan,
    ...queryParams,
  });

export default useAddPlanMutation;
